/**
 * @param {HTMLElement | string} element
 * @param {boolean} [alignToTop=true] - If true, the top of the element will be aligned to the top of the visible area of the scrollable ancestor.
 * @param {boolean} [smooth=true] - If true, then uses `scrollIntoViewOptions`.
 */
export const scrollElementIntoView = (element: HTMLElement | string | null, alignToTop = true, smooth = true): void => {
    if (typeof element === "string") {
        element = document.querySelector<HTMLElement>(element);
    }

    if (element && element.scrollIntoView !== undefined) {
        if (smooth) {
            element.scrollIntoView({
                behavior: alignToTop ? "smooth" : "auto",
                block: alignToTop ? "start" : "center",
                inline: alignToTop ? "nearest" : "center",
            });
        } else {
            element.scrollIntoView(alignToTop);
        }
    }
};

export const scrollElementIntoViewWithOffset = (
    element: HTMLElement | string | null,
    topOffset = 0,
    alignToTop = true,
    parentElement: HTMLElement | string | null | (Window & typeof globalThis) = window,
): void => {
    if (typeof element === "string") {
        element = document.querySelector<HTMLElement>(element);
    }

    if (!parentElement) parentElement = window;

    if (typeof parentElement === "string") {
        parentElement = document.querySelector<HTMLElement>(parentElement);
    }

    if (element && parentElement) {
        const elementPosition = element.offsetTop;
        const offsetPosition = elementPosition - topOffset;

        parentElement.scrollTo({
            top: offsetPosition,
            behavior: alignToTop ? "smooth" : "auto",
        });
    }
};
